/*
 * @Author: edvardchen
 * @Date:   2016-11-03 21:11:25
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 16:31:17
 */

/**
 * for client usage
 */
export function parseJSON(response) {
  const url = response.url || '';
  return response.text().then((text) => {
    if (text.length) {
      try {
        return JSON.parse(text);
      } catch (error) {
        console.log(`fetch reponse,url:${url}`, error);
        return {};
      }
    }
  });
}

export function checkStatus(response = {}) {
  if (response && response.status >= 200 && response.status < 300) {
    return response;
  }
  return parseJSON(response)
    .catch(() => undefined)
    .then((body) => {
      const error = new Error(response.statusText);
      error.response = response;
      error.body = body;
      if (body && body.message) {
        error.message = body.message;
      }
      throw error;
    });
}
